import api from "./axios";

export const verifyParticipant = (payload) =>
  api.post("/appointment-booking/verification-participant", payload).then(r => r.data);

export const verificationMyBooking = (payload) =>
  api.post("/appointment-booking/verification-my-booking", payload).then(r => r.data);

export const getAvailablePsikolog = (payload) =>
  api.post("/appointment-booking/get-availabe-psikolog", payload).then(r => r.data);

export const getAvailablePsikologDetail = (payload) =>
  api.post("/appointment-booking/get-availabe-psikolog-detail", payload).then(r => r.data);

export const storeBooking = (payload) =>
  api.post("/appointment-booking/store-booking", payload).then(r => r.data);

export const getBookingDetail = () =>
  api.get("/appointment-booking/booking-detail").then(r => r.data);
